<template>
  <div id="orderDetail">
	<div class="detail_title">订单明细</div>
	<div class="detail_body">
		<div class="title">{{ mealInfo.setMelName }}</div>
		<div class="detail_row" v-if="mealInfo.orderCode">
			<div class="detail_label">订单编号：</div>
			<div class="detail_value">{{ mealInfo.orderCode }}</div>
		</div>
		<!-- <div class="detail_row">
			<div class="detail_label">套餐简介：</div>
			<div class="detail_value">{{ mealInfo.introduce }}</div>
		</div> -->
		<div class="detail_row">
			<div class="detail_label">套餐内容：</div>
			<div class="detail_value module">
				<template v-for="m in modules">
					<template  v-for="mm in m.appFunctionList" >
						<span class="aModule" :key="mm.id" v-if="mm.funType == 1 || funCodeArr.includes(mm.functionCode)">
							{{mm.name}}</span>
					</template>
				</template>
			</div>
		</div>
		<div class="detail_row">
			<div class="detail_label">服务器支持人数：</div>
			<div class="detail_value">{{ mealInfo.attributeData.serverPeopleNum }}人</div>
		</div>
		<div class="detail_row">
			<div class="detail_label">圈子数量上限：</div>
			<div class="detail_value">{{ mealInfo.attributeData.circleNum }}个</div>
		</div>
		<div class="detail_row">
			<div class="detail_label">管理员数量上限：</div>
			<div class="detail_value">{{ mealInfo.attributeData.adminNum }}人</div>
		</div>
		<!-- <div class="detail_row">
			<div class="detail_label">是否支持Kurento：</div>
			<div class="detail_value">{{ mealInfo.attributeData.isKurento ? '支持' : '不支持'}}</div>
		</div> -->
		<div class="detail_row">
			<div class="detail_label">购买邮箱：</div>
			<div class="detail_value">{{ mealInfo.email}}</div>
		</div>
		<div class="detail_row" v-if="mealInfo.activationTime">
			<div class="detail_label">激活时间：</div>
			<div class="detail_value">$ {{ mealInfo.activationTime}}</div>
		</div>
		<div class="detail_row" v-if="mealInfo.expireTime">
			<div class="detail_label">到期时间：</div>
			<div class="detail_value">$ {{ mealInfo.expireTime}}</div>
		</div>
		<div class="detail_row" v-if="mealInfo.orderStatus">
			<div class="detail_label">订单状态：</div>
			<div class="detail_value">
				<span style="color:green" v-if="mealInfo.orderStatus == 6">已完成</span>
				<span style="color:red" v-if="mealInfo.orderStatus == 1">待支付</span>
				<span style="color:#ccc" v-if="mealInfo.orderStatus == 5">已关闭</span>
				<span style="color:red" v-if="mealInfo.orderStatus == 2">待激活</span>
			</div>
		</div>
		<div class="detail_row">
			<div class="detail_label">支付金额：</div>
			<div class="detail_value">$ {{ mealInfo.resultPrice.toFixed(2)}}</div>
		</div>

		<div class="operaBox">
			<template v-if="!mealInfo.orderStatus">
				<div class="price_box">
					需要支付金额：<span class="price">${{mealInfo.resultPrice.toFixed(2)}}</span>
				</div>
				<el-button type="primary" style="margin-left:20px;" @click="createOrder">确认购买</el-button>
			</template>
			<template v-else-if="mealInfo.orderStatus == 1">
				<div class="price_box">
					需要支付金额：<span class="price">${{mealInfo.resultPrice.toFixed(2)}}</span>
				</div>
				<div class="cancel" @click="cancelOrder">取消订单</div>
				<el-button type="primary" @click="readyPay">立即支付</el-button>
			</template>
			<template v-else-if="mealInfo.orderStatus == 2">
				<el-button type="primary" @click="createdCDKEY">生成激活码</el-button>
			</template>
			<template v-else>
				<el-button @click="viewMachineCode" v-if="mealInfo.machineCode">查看注册码</el-button>
				<el-button type="primary" @click="viewActivationCode" v-if="mealInfo.activationCode">查看激活码</el-button>
			</template>
				<!-- <el-button @click="readyPay">查看机器码</el-button>
				<el-button type="primary" @click="readyPay">查看激活码</el-button> -->
		</div>
	</div>

    <!-- <div>订单类型： 在线安装</div>	
    <div>套餐名称：{{ mealInfo.name }}</div>
    <div v-if="mealInfo.introduce">套餐简介：{{ mealInfo.introduce }}</div>
    <div v-if="modules && funCodeArr">
      套餐服务：
      <div v-for="m in modules" :key="m.id">
        <template v-for="mm in m.children">
          <div
            :key="mm.id"
            v-if="mm.funType == 1 || funCodeArr.includes(mm.functionCode)"
          >
            {{ mm.name }}
          </div>
        </template>
      </div>
    </div>
    <div v-if="mealInfo.firstUpdateTime">
      创建时间：{{ mealInfo.firstUpdateTime }}
    </div>
    <div v-if="mealInfo.expireTime">到期时间：{{ mealInfo.expireTime }}</div>
    <div>时长：12月</div>
    <div>用户邮箱： {{ mealInfo.email }}</div>
    <div>支付金额: ${{ mealInfo.resultPrice.toFixed(2) }}</div>
    <div v-if="mealInfo.machineCode" style="word-break: break-all">
      机器码：{{ mealInfo.machineCode }}
    </div>
    <div v-if="mealInfo.activationCode" style="word-break: break-all">
      激活码：{{ mealInfo.activationCode }}
    </div>
    <div>
      <button @click="createOrder" v-if="!mealInfo.orderStatus">
        确认购买
      </button>
      <button
        @click="cancelOrder"
        v-if="mealInfo.orderStatus && mealInfo.orderStatus == 1"
      >
        取消订单
      </button>
      <button
        @click="readyPay"
        v-if="mealInfo.orderStatus && mealInfo.orderStatus == 1"
      >
        立即支付
      </button>
      <button
        @click="createdCDKEY"
        v-if="
          mealInfo.orderStatus == 6 &&
          !mealInfo.machineCode &&
          !mealInfo.activationCode
        "
      >
        生成激活码
      </button>
    </div> -->



    <pay ref="pay" :callback="() => $router.push('/orderHistory')" 
        :cancelCallback="() => $router.push('/orderHistory')"></pay>
    <cdkey ref="cdkey" :callback="cdkeyCallback"></cdkey>
  </div>
</template>
<style lang="scss">
@import "../assets/template/css/bootstrap.min.css";
@import "../assets/template/css/style.css";
@import "../assets/template/css/responsive.css";
@import "../assets/template/css/colors.css";
@import "../assets/template/css/animate.css";
#orderDetail {
	.detail_title{
		font-weight: bold;
		margin-top:10px;
		margin-bottom:5px;
	}
	.detail_body{
		background:#fff;
		padding:30px 25px;
		.title{
			font-size:18px;
			font-weight: bold;
			margin-bottom:20px;
		}
		.detail_row{
			display:flex;
			align-items: center;
			margin-bottom:15px;
			.detail_label{
				color:#666;
				font-size:12px;
        white-space: nowrap;
			}
      .detail_value{
        flex-grow: 1;
        max-width: 600px;
      }
			.module{
              .aModule{
                background:url("../assets/img2/contain.png") no-repeat left center;
                display:inline-block;
                line-height:24px;
                padding-left: 22px;
                background-size: 18px;
                margin-right:15px;
                margin-bottom:5px;
              }
			}
		}
		.operaBox{	
		    display: flex;
			justify-content: flex-end;
			align-items: center;
			.price_box{
				color:#666666;
				.price{
					color:#3FB8A4;
				}
			}
			.cancel{
				cursor: pointer;
				margin:0 20px;
			}
		}
	}
}
</style>

<script>
import server from "@/public/service";
import { SUCCESS_CODE } from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import pay from "@/components/pay.vue";
import cdkey from "@/components/cdkey.vue";
import moment from "moment";

// RxJS v6+
import { interval } from 'rxjs';

const source = interval(1000);
export default {
  title: "Dingo Group",
  data() {
    return {
      mealInfo: {
        id:"",
        setMelName:"",
        orderCode:"",
        introduce:"",
        attributeData:{},
        email:"",
        activationTime:"",
        expireTime:"",
        orderStatus: undefined,
        resultPrice:0,
        funCode:"",
        userId:"",
        orderId:"",
        modules:[],
        machineCode:"",
        activationCode:""
      },
      funCodeArr: [],
      modules: [],

    };
  },
  components: {
    pay,
    cdkey,
  },
  methods: {
    readyPay() {
      this.$refs.pay.show(this.mealInfo);
    },
    createOrder() {
      var params = {
        orderType: 1,
        setMealId: this.mealInfo.id,
        funCode: this.mealInfo.funCode,
        userEmail: this.mealInfo.email,
        payment: this.mealInfo.resultPrice,
        paymentType: 1,
        postFee: 0,
        userId: this.mealInfo.userId,
      };
      server.createOrder(params).then((data) => {
        if (data.reCode === SUCCESS_CODE) {
          var result = getInterfaceData(data);
          this.mealInfo.orderCode = result.orderCode;
          this.mealInfo.orderId = result.orderId;
          this.mealInfo.orderStatus = 1;

          var firstTime = moment().format("x")*1; //创建订单时间
          this.mealInfo.lastTime = firstTime + 1800000;
          this.mealInfo.countTimeDesc = "30:00"; //倒计时
          this.mealInfo.subscribe = source.subscribe(()=>{
              var time = this.mealInfo.lastTime - (moment().format("x")*1);
              if(time > 0){
                this.mealInfo.countTimeDesc = moment(time).format("mm:ss");
              }else{
                this.mealInfo.countTimeDesc = "";
                this.mealInfo.subscribe.complete();
              };
          });
          setTimeout(()=>{
            
            this.readyPay();
          },500)
          
        }
      });
    },
    cancelOrder() {
      this.$confirm("确定取消该订单？").then(() => {
        var params = {
          userId: this.$store.state.userInfo.id,
          orderId: this.mealInfo.orderId,
        };
        server.cancelOrder(params).then((data) => {
          if (data.reCode === SUCCESS_CODE) {
            this.$message({
              type: "success",
              message: "取消成功",
              showClose: true,
            });
            this.$router.push("/orderHistory");
          }
        });
      });
    },
    getModule() {
      if (this.mealInfo && this.mealInfo.modules) return;
      if (!this.mealInfo.funCode) return;
      try {
        this.funCodeArr = JSON.parse(this.mealInfo.funCode).fun_code.split(",");
      } catch (e) {
        console.log("aaaa", e);
      }
      if (!this.funCodeArr.length) return;
      server.getModule().then((data) => {
        if (data.reCode === SUCCESS_CODE) {
          var result = getInterfaceData(data);
          Promise.all(
            result.map((v) => {
              return server.getService({
                moduleId: v.id,
                size: 999,
                current: 1,
              });
            })
          ).then((_data) => {
            var modules = [];
            _data.forEach((vv, i) => {
              if (vv.reCode === SUCCESS_CODE) {
                var _result = getInterfaceData(vv);
                modules.push({
                  moduleName: result[i].moduleName,
                  id: result[i].id,
                  children: _result.records.filter(
                    (v) =>
                      v.funType == 1 || this.funCodeArr.includes(v.functionCode)
                  ),
                });
              }
            });
            setTimeout(()=>{
              this.modules = modules;
            },500)
          });
        }
      });
    },
    getAllModules(){
        server.getAllModules().then(data=>{
            if(data.reCode === SUCCESS_CODE){
                var result = getInterfaceData(data);
                // this.$nextTick(()=>{
                // 	this.modules = result;
                // })
                setTimeout(()=>{
                  this.modules = result;
                },100)
            };
        });
    },
    cdkeyCallback({ machineCode, activationCode }) {
      this.mealInfo.machineCode = machineCode;
      this.mealInfo.activationCode = activationCode;
    },
    createdCDKEY() {
      this.$refs.cdkey.show(this.mealInfo.id || this.mealInfo.orderId);
    },
    viewMachineCode(){
      console.log("this.mealInfo",this.mealInfo)
      this.$refs.cdkey.viewMachineCode(this.mealInfo.machineCode);
    },
    viewActivationCode(){
      this.$refs.cdkey.viewActivationCode(this.mealInfo.activationCode);
    }
  },
  created() {
    if (this.$store.state.orderDetail) {
		  this.getAllModules();
      var mealInfo = JSON.parse(JSON.stringify(this.$store.state.orderDetail));
      this.$store.state.orderDetail = undefined;
      mealInfo.email = this.$store.state.userInfo.email;
      mealInfo.userId = this.$store.state.userInfo.id;
      mealInfo.setMelName = mealInfo.setMelName || mealInfo.name || "";
      mealInfo.introduce = mealInfo.introduce || "";
      //   mealInfo.resultPrice = mealInfo.payment ? '$' + mealInfo.payment :
      //     mealInfo.originalPrice ? `$${mealInfo.originalPrice}` : "0";
	  mealInfo.resultPrice = mealInfo.payment || mealInfo.discountPrice || mealInfo.originalPrice || 0;
	  mealInfo.attributeData = {};
	  try{
		  	mealInfo.attributeData = JSON.parse(mealInfo.attribute || "{}");
        this.funCodeArr = JSON.parse(mealInfo.funCode || "{}").fun_code;
	  }catch(e){
		//   mealInfo.attributeData = {};
		console.log("error:",e);
	  };
      mealInfo.machineCode = mealInfo.machineCode || "";
      mealInfo.activationCode = mealInfo.activationCode || "";
      this.mealInfo = mealInfo;
      // this.getModule();
    } else {
      this.$router.push("/orderHistory");
    }
    console.log("funCode", this.mealInfo);
  },
};
</script>
